<template>
    <div class="bind-taobao">
        <div class="card">
            <div class="bind-message">
                <van-icon name="close" size="6em" color="#ff4b5c" v-if="status == 3" />
                
                <div  v-if="status == 1" class="loading">

                   <van-loading size="40px" type="spinner"></van-loading>
                </div>
                
                
                <van-icon name="certificate" size="6em" color="#23b66f" v-if="status == 2" />
            </div>
            <div class="van-hairline--bottom"></div>
            <div class="content">
                <h1  v-if="status == 1">信息获取中</h1>
                <h1  v-else>{{message}}</h1>

            </div>
            <div class="contentMsg" v-if="status == 3 ">
                <div>1.绑定失败请关闭页面尝试重新获取授权</div>
                <div>2.若该帐号被其它用户绑定，请联系客服</div>
                <div>3.多次绑定失败请联系客服处理</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon ,Loading  } from 'vant';
export default {
    data() {
        return {
            status: 1 ,// 授权状态：1授权中  2授权成功 3授权失败
            info:{},
            tbdata:"",
            userinfo:"",
            message:"",
        };
    },
    created() {
        var params = this.$route.query;
        this.sendBindTaobaoQuery(params);
    },
	components:{
		Icon,
		Loading,
	},
    methods: {
        sendBindTaobaoQuery(params) {
            if (params.code && params.state) {
                this.$Request.post('oauth/bind', params).then(res => {
                    this.message = res.msg;
                    if (res.code == 200) {
                        this.status = 2;
                        this.tbdata = JSON.stringify( res.data.tbdata);
                        this.userinfo = JSON.stringify( res.data.userinfo);
                        setTimeout(r=>{
							suni.switchTab({
								url:"/pages/member/index"
							})
						},500)
                    } else {
                        this.status = 3;
                        this.info = res.data;
                    }
                });
            }
        }
    }
};
</script>
<style>
body,
.bind-taobao {
    background: #f0f3f6;
}
.bind-taobao .card {
    background: #ffffff;
    width: 90%;
    border-radius: 20px;
    padding: 20px;
    margin: 0 auto;
    margin-top: 20px;
    height: auto;
}
.bind-taobao .card .bind-message {
    text-align: center;
    margin: 0 auto;
    margin-top: 10px;
}
.bind-taobao .card .bind-message  .loading{
    width: 20%;
    left: 45%;
    position: relative;
}
.bind-taobao .card .not-data {
    background: url(../../assets/image_notdata2.png) center center no-repeat rgba(245, 245, 245, 0.05);
    background-size: 100%;
    width: 100%;
    height: 100%;
    line-height: 100%;
}
.content h1{
    font-size: 30px;
    margin-top: 40px;
    margin-bottom: 20px;
}
.contentMsg{
    text-align: left;
    padding: 10px;
}
.contentMsg div{
    font-size: 25px;
    line-height: 60px;
}
.contentMsg div span{
    width:150px;
    text-align: left;
    display: inline-block;
}
</style>
